export default __webpack_public_path__ + "static/media/7osisf.c5443f50.webp";